import { render, staticRenderFns } from "./FIBMember.vue?vue&type=template&id=45a7eda2&scoped=true&"
import script from "./FIBMember.vue?vue&type=script&lang=js&"
export * from "./FIBMember.vue?vue&type=script&lang=js&"
import style0 from "./FIBMember.vue?vue&type=style&index=0&id=45a7eda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7eda2",
  null
  
)

export default component.exports